// extracted by mini-css-extract-plugin
export default {"desktop-view":"tUI8U","image":"hyVIR"};